import React from 'react';
import { graphql } from 'react-relay';
import { Query } from '../../.';
import { populateChildren } from '../toolbox';

export const QUsersQuery = graphql`
  query QUsersQuery {
    users {
      id
      email
      status
      roles
      dates {
        signUp
      }
      teamRoles {
        teamId
        name
        roles {
          role
          offerId
        }
      }
    }
  }
`;

const QUsers = ({
  children,
  args,
  childDataProp
}) => (
  <Query
    query={QUsersQuery}
    args={args}
  >
    {populateChildren('users')(children, childDataProp)}
  </Query>
);

export default QUsers;
